import React from 'react';
import DesktopExpandedLayout from '../../components/common/DesktopExpandedLayout';
import { useDesktopExpanded } from '../../hooks/useDesktopExpanded';
import '../../styles/desktop-expanded.css';

/**
 * LearningStatus 페이지의 데스크톱 확장 래퍼
 * 
 * 기존 LearningStatus 로직은 그대로 유지하면서
 * 데스크톱에서만 레이아웃을 확장하는 래퍼 컴포넌트
 */
export const LearningStatusDesktop = ({ 
  children,
  areas,
  loading,
  ...props 
}) => {
  // 데스크톱 확장 훅 사용
  const {
    isMobileView,
    createLayoutConfig,
    getCSSVariables
  } = useDesktopExpanded({
    expandConfig: {
      mode: 'horizontal', // 3개 영역 가로 배치
      maintainMobileWidth: false // 영역별로 다르게 설정
    }
  });

  // 영역별 데스크톱 설정
  const desktopAreas = areas ? {
    area1: {
      content: areas.area1,
      config: {
        minWidth: '360px',
        maintainMobileWidth: true, // 학생 목록은 모바일 너비 유지
        flex: 'none'
      }
    },
    area2: {
      content: areas.area2,
      config: {
        minWidth: '360px',
        maintainMobileWidth: true, // 테스트 이력도 모바일 너비 유지
        flex: 'none'
      }
    },
    area3: {
      content: areas.area3,
      config: {
        flex: '1 1 auto',
        minWidth: '600px',
        maintainMobileWidth: false // 상세 정보는 확장 허용
      }
    }
  } : null;

  // 레이아웃 구성 생성
  const layoutConfig = createLayoutConfig(desktopAreas);

  return (
    <div style={getCSSVariables()}>
      <DesktopExpandedLayout
        {...props}
        loading={loading}
        areas={layoutConfig.mode === 'stack' ? null : layoutConfig.areas}
        expandMode={layoutConfig.mode}
        expandConfig={{
          wrap: false
        }}
        className="desktop-learning-status"
        renderContent={({ isMobileView }) => {
          // 모바일에서는 children 그대로 렌더링
          if (isMobileView) {
            return children;
          }
          // 데스크톱에서는 areas로 처리됨
          return null;
        }}
      />
    </div>
  );
};

/**
 * LearningStatus 페이지에서 사용할 수 있는 유틸리티 함수
 */
export const createLearningStatusAreas = (components) => {
  const { studentListComponent, testHistoryComponent, detailComponent } = components;
  
  return {
    area1: studentListComponent,
    area2: testHistoryComponent,
    area3: detailComponent
  };
};

/**
 * 페이지네이션 컴포넌트 (데스크톱 전용)
 */
export const DesktopPagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange,
  className = ''
}) => {
  return (
    <div className={`desktop-pagination ${className}`}>
      <button 
        className="page-button"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage <= 1}
      >
        이전
      </button>
      
      <div className="flex gap-1">
        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
          const pageNum = i + 1;
          return (
            <button
              key={pageNum}
              className={`page-button ${currentPage === pageNum ? 'active' : ''}`}
              onClick={() => onPageChange(pageNum)}
            >
              {pageNum}
            </button>
          );
        })}
      </div>
      
      <span className="page-info">
        {currentPage} / {totalPages}
      </span>
      
      <button 
        className="page-button"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage >= totalPages}
      >
        다음
      </button>
    </div>
  );
};